module.exports = __webpack_public_path__ + "img/segment.faafc6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/integrations/segment.png
// module id = mEmZ
// module chunks = 39 44